import React from 'react';
import { Link } from 'react-router-dom';

interface CustomLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

const CustomLink: React.FC<CustomLinkProps> = ({
  to,
  children,
  className = '',
}) => {
  return (
    <Link
      to={to}
      className={`text-white hover:text-gray-300 transition-colors duration-200 font-medium ${className}`}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
